export default __webpack_public_path__ + "static/media/icon-bestellung-eingang-dtc.eb1943b7.svg";